module.exports = __webpack_public_path__ + "static/core-value-13efbada74059f59fc710a7083d8c782.png";